import React, { lazy, Suspense, useMemo, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
const FloatingMessagingWidget = lazy(() => import("../CleanSlateApp/Users/Master/Modals/MessageModal/FloatingMessagingWidget"));
const WIDGET_HIDDEN_PATHS = ["personaldiary", "/inbox"];

const ProtectedRoute = ({ children }) => {
	const token = Cookies.get("token");
	const location = useLocation();

	const isAuthorized = useMemo(() => {
		if (!token) return false;
		try {
			const decoded = jwtDecode(token);
			return decoded.exp > Date.now() / 1000;
		} catch (error) {
			return false;
		}
	}, [token]);

	useEffect(() => {
		if (token && !isAuthorized) {
			Cookies.remove("token");
		}
	}, [token, isAuthorized]);
	if (!isAuthorized) { return <Navigate to="/Auth" replace state={{ from: location }} />; }
	const normalizedPath = String(location.pathname || "").toLowerCase();
	const hideFloatingWidget = WIDGET_HIDDEN_PATHS.some(path => normalizedPath.includes(path.toLowerCase())
	);

	return (
		<>
			{children}
			<Suspense fallback={null}>
				{!hideFloatingWidget && <FloatingMessagingWidget />}
			</Suspense>
		</>
	);
};

export default ProtectedRoute;
